import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { isNil, isEmpty } from "lodash";

import styles from "./reports.module.css";
import { getReports } from "../../store/reports/actions";

const Reports = () => {
  const dispatchito = useDispatch();
  const user = useSelector(state => state.user);
  const organizationId = useSelector(state => state.organizations.organizationId);
  const organizations = useSelector(state => state.organizations.organizations);
  const data = useSelector(state => state.reports?.data);
  const [loading,setLoading] = useState(true);
  const [orgIds, setOrgIds]= useState([]);

  useEffect(()=>{
    if(!(user?.role?.includes("masterEditor"))){
      dispatchito(getReports(user));
    }
  },[user,organizationId])

  useEffect(()=>{
    if (!isEmpty(organizations)) setOrgIds(organizations.map(i => i?.taxId))
  },[organizations])

  const [reportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    accessToken: undefined,
    id: undefined,
    tokenType: models.TokenType.Aad,
    settings: {
      filterPaneEnabled: false,
      navContentPaneEnabled: true,
    }
    // settings: {
    //   panes: {
    //     filters: {
    //       expanded: false,
    //       visible: false
    //     }
    //   },
    //   // background: models.BackgroundType.Transparent,
    // }
  });

  useEffect(() => {
    if(!isNil(data?.embedUrl) && !isEmpty(orgIds) && !isEmpty(user)){
      setReportConfig({
        ...reportConfig,
        embedUrl: data?.embedUrl,
        accessToken: data?.token,
        id: data?.id,
        filters: user?.role === "assignedUser" ? [
          {
              $schema: "http://powerbi.com/product/schema#basic", //"http://powerbi.com/product/schema#advanced"
              target: {
                  table: "organizations", //table name
                  column: "taxId", //table column name for filter
              },
              operator: "In", //eq, in etc
              values: orgIds, //organizationId, //array of values eg. [123,49],
          },
          {
            $schema: "http://powerbi.com/product/schema#basic", //"http://powerbi.com/product/schema#advanced"
            target: {
                table: "users", //table name
                column: "_id", //table column name for filter
            },
            operator: "In", //eq, in etc
            values: [user?.userId], //organizationId, //array of values eg. [123,49],
          },       
        ] : [
          {
              $schema: "http://powerbi.com/product/schema#basic", //"http://powerbi.com/product/schema#advanced"
              target: {
                  table: "organizations", //table name
                  column: "taxId", //table column name for filter
              },
              operator: "In", //eq, in etc
              values: orgIds, //array of values eg. [123,49],
          }
        ],
      })
      setLoading(false);
    }
  }, [data, user, orgIds]);

  return (
    loading ?
    <></>
    :
    <div className="reports-main-content">
      <div className={styles["powerbi-report-style-class"]}>
        <PowerBIEmbed
          cssClassName={styles['report-style-class']}
          embedConfig = {reportConfig}
        />
      </div>
    </div>
  );
};

export default Reports;
